import _ from 'underscore'

export const createLoadingSelector = (actions) => (state) => {
  return _(actions).some(action => {
    return state.requestsStatus?.[action]?.isFetching
  })
}